export default "__VITE_ASSET__wdAcxE0Q__"